'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var coreRenderer = require('@tempi/core-renderer');
var index = require('../types/index.js');

const BREAK_POINTS = {
  xs: "480px",
  sm: "576px",
  md: "768px",
  lg: "1024px",
  xl: "1440px",
  xxl: "1600px"
};
const GRID_COLUMNS = 12;
const MAPPING_VERTICAL_ALIGNMENT_FLEX = {
  [coreRenderer.VerticalAlignment.top]: "flex-start",
  [coreRenderer.VerticalAlignment.center]: "center",
  [coreRenderer.VerticalAlignment.bottom]: "flex-end"
};
const MAPPING_ALIGNMENT_FLEX = {
  [coreRenderer.Alignment.center]: "center",
  [coreRenderer.Alignment.left]: "flex-start",
  [coreRenderer.Alignment.right]: "flex-end",
  [coreRenderer.Alignment.justify]: "space-between"
};
const DEFAULT_WIDTH = 1232;
const DEFAULT_HEIGHT = 400;
const DEFAULT_GUTTER = [0, 0];
const WIDTH_TYPE_OPTIONS = [
  { label: "To\xE0n b\u1ED9 chi\u1EC1u r\u1ED9ng", value: index.WidthTypeEnum.full },
  { label: "T\xF9y ch\u1EC9nh", value: index.WidthTypeEnum.fixed }
];

exports.BREAK_POINTS = BREAK_POINTS;
exports.DEFAULT_GUTTER = DEFAULT_GUTTER;
exports.DEFAULT_HEIGHT = DEFAULT_HEIGHT;
exports.DEFAULT_WIDTH = DEFAULT_WIDTH;
exports.GRID_COLUMNS = GRID_COLUMNS;
exports.MAPPING_ALIGNMENT_FLEX = MAPPING_ALIGNMENT_FLEX;
exports.MAPPING_VERTICAL_ALIGNMENT_FLEX = MAPPING_VERTICAL_ALIGNMENT_FLEX;
exports.WIDTH_TYPE_OPTIONS = WIDTH_TYPE_OPTIONS;
